module.exports = __webpack_public_path__ + "static/Top banner-c0d5d23412366eb3d20d5e5bfeb29965.png";